import React, { useState, useEffect } from "react";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import moment from "moment";

const MyTeamTrainingIncentive = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    fetchIncentiveTraining();

    dispatch(updateNavbarHeading("My Team Training Incentive"));
  }, []);
  const [trainingIncentiveData, setTrainingIncentiveData] = useState([]);
  const [statusOption, setStatusOption] = useState([]);
  const [employeeOption, setEmployeeOption] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, SetApiStatus] = useState(undefined);


  const todayDate = moment().format("YYYY-MM-DD");
  const lastMonthDate = moment().subtract(1, "months").format("YYYY-MM-DD");

  const initialData = [
    { label: "Employee", value: "" },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
    { label: "Status", value: "" },
  ];
  const [filterFormData, setFilterData] = useState(initialData);
  const columns = {
    Employee: { text: "Employee", visible: true },
    Client: { text: "Client", visible: true },
    ProjectName: { text: "Project", visible: true },
    FromDate: { text: "From", align: "center", visible: true },
    ToDate: { text: "To", align: "center", visible: true },
    // std: { text: "STD.Rate",align:"center", visible: true },
    days: { text: "#Days", align: "center", visible: true },
    // days: { text: "Include Holiday",align:"center", visible: true },
    // CloseDate: { text: "Close Date",align:"center", visible: true },
    TotalAmount: { text: "Total Amount", align: "end", visible: true },
    // ApprAmount: { text: "Appr.Amount",align:"center", visible: true },
    ApplicationStatus: { text: "Status", align: "center", visible: true },
  };

  const fetchIncentiveTraining = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/reports/6?P_Status=&P_EmployeeID=&P_FromDate=${lastMonthDate}&P_ToDate=${todayDate}
        `
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const incentiveData = response?.data?.data?.data;
        setTrainingIncentiveData(incentiveData);

        // Status List
        const statusData = response?.data?.data?.status;
        const statusList = statusData?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setStatusOption(statusList);

        // Employee List
        const empData = response?.data?.data?.employee;
        const empList = empData?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setEmployeeOption(empList);
      } else {
        console.error(
          "Failed to fetch Training Incentive. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Training Incentive", error);
    }
  };

  const handleGetData = async () => {
      SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/reports/6?P_Status=${filterFormData.find((o) => o.label === "Status")
          ? filterFormData.find((o) => o.label === "Status").value
          : ''
        }&P_EmployeeID=${filterFormData.find((o) => o.label === "Employee")
          ? filterFormData.find((o) => o.label === "Employee").value
          : ''
        }&P_FromDate=${filterFormData.find((o) => o.label === "From Date")
          ? moment(
            filterFormData.find((o) => o.label === "From Date").value
          ).format("YYYY-MM-DD")
          : lastMonthDate
        }&P_ToDate=${filterFormData.find((o) => o.label === "To Date")
          ? moment(
            filterFormData.find((o) => o.label === "To Date").value
          ).format("YYYY-MM-DD")
          : todayDate
        }`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const incentiveData = response?.data?.data?.data;
        setTrainingIncentiveData(incentiveData);

        // Status List
        const statusData = response?.data?.data?.status;
        const statusList = statusData?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setStatusOption(statusList);

        // Employee List
        const empData = response?.data?.data?.employee;
        const empList = empData?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setEmployeeOption(empList);
      } else {
        console.error(
          "Failed to fetch Training Incentive. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Training Incentive", error);
    }
  };

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };
  const formDatas = [
    { name: "Employee", type: "Select", options: [...employeeOption] },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
    { name: "Status", type: "Select", options: [...statusOption] },
  ];
  const handleFilterReset = () => {
    // Reset to empty/default values without passing any specific data
    setFilterData([
      { label: "Employee", value: "" },
      { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
      { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
      { label: "Status", value: "" },]);
    // Call API with empty/default parameters
    handleGetData();
    fetchIncentiveTraining();
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={trainingIncentiveData}
              columns={columns}
              itemsPerPage={10}
              isSorting={true}
              showIcon2={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isFilterRequired={true}
              formDatas={formDatas}
              handleGetData={handleGetData}
              handleReset={handleFilterReset}
              handleChange={handleChange}
              filterFormData={filterFormData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MyTeamTrainingIncentive;
